import React, { useMemo } from 'react';
import { Chart, CommonSeriesSettings, Series, Legend, Label, Format, ValueAxis, Grid } from 'devextreme-react/chart';
import { LoadPanel } from 'devextreme-react/load-panel';
import 'devextreme/dist/css/dx.light.css';

var chartInstanceNum = 1;

const ChartBase = ({ data, argumentField, series, type = 'bar', height=400, legendSettings = { verticalAlignment: 'bottom', horizontalAlignment: 'center', visible: true, border: { color: '#FFB50C', width: 1, visible: true } }, children }) => {
    
    const chartId = useMemo(() => `C${chartInstanceNum++}`, []);
    return (
        <Chart id={chartId} dataSource={data} height={height}>
            <CommonSeriesSettings argumentField={argumentField} type={type} />

            {series?.map((s) => (
                <Series key={s.valueField ?? s.name} {...s} />
            ))}

            <ValueAxis>
                <Grid visible={true} />
            </ValueAxis>

            <Legend
                verticalAlignment={legendSettings?.verticalAlignment}
                horizontalAlignment={legendSettings?.horizontalAlignment}
                border={legendSettings?.border}
                visible={legendSettings?.visible}
            />

            {children}
        </Chart>
    );
};

export default ChartBase;
